import {
  analysisResponseSchema,
  watchlistItemSchema,
  type AnalysisResponse,
  type DvfPropertyType,
  type WatchlistInput,
  type WatchlistItem,
  type WatchlistUpdate,
} from '@app/shared';
import { z } from 'zod';
import { apiFetch } from '@/lib/api';

export function fetchWatchlist(): Promise<WatchlistItem[]> {
  return apiFetch('/api/market/watchlist', { schema: z.array(watchlistItemSchema) });
}

export function addToWatchlist(input: Partial<WatchlistInput> & Pick<WatchlistInput, 'inseeCode' | 'communeName'>): Promise<WatchlistItem> {
  return apiFetch('/api/market/watchlist', { method: 'POST', body: input, schema: watchlistItemSchema });
}

export function updateWatchlistItem(id: number, update: WatchlistUpdate): Promise<WatchlistItem> {
  return apiFetch(`/api/market/watchlist/${id}`, { method: 'PATCH', body: update, schema: watchlistItemSchema });
}

export function fetchAnalysis(codes: readonly string[], propertyType: DvfPropertyType): Promise<AnalysisResponse> {
  const params = new URLSearchParams({ codes: codes.join(','), propertyType });
  return apiFetch(`/api/market/analysis?${params.toString()}`, { schema: analysisResponseSchema });
}
